import React from "react";
import container from "./images/Container.svg";
import image from "./images/Image.svg";
import text from "./images/Text.svg";
import slider from "./images/Slider.svg";

const Fa = ({ i }) => <i className={"fa fa-" + i} />;

const Img = ({ p }) => <img alt="" width="100%" height="100%" src={p} />;

export const Redo = p => <Fa i="repeat" />;
export const Undo = p => <Fa i="undo" />;
export const Export = p => <Fa i="upload" />;
export const Table = p => <Fa i="table" />;
export const Battery = p => <Fa i="battery-3" />;
export const CaretDown = p => <Fa i="caret-down" />;
export const CaretRight = p => <Fa i="caret-right" />;
export const Remove = p => <Fa i="times" />;
export const Plug = p => <Fa i="plug" />;
export const Clone = p => <Fa i="clone" />;
export const Link = p => <Fa i="link" />;
export const Keyboard = p => <Fa i="keyboard-o" />;
export const Login = p => <Fa i="sign-in" />;
export const Logout = p => <Fa i="sign-out" />;
export const Clock = p => <Fa i="clock-o" />;
export const Video = p => <Fa i="video-camera" />;
export const Dashboard = p => <Fa i="tachometer" />;
export const Scene = p => <Fa i="television" />;
export const UserCircle = p => <Fa i="user-o" />;
export const ExternalLink = p => <Fa i="external-link" />;
export const FontAwesome = p => <Fa i="fa" />;
export const Add = p => <Fa i="plus-square" />;
export const Outline = p => <Fa i="square-o" />;
export const Preview = p => <Fa i="eye" />;
export const Delete = p => <Fa i="trash-o" />;
export const Duplicate = p => <Fa i="clone" />;
export const BringFront = p => <Fa i="arrow-up" />;
export const SendBack = p => <Fa i="arrow-down" />;
export const Lock = p => <Fa i="lock" />;
export const Unlock = p => <Fa i="unlock" />;
export const Hide = p => <Fa i="eye-slash" />;

// export const Outline = p => <Img p={outline} />;
// export const Undo = p => <Img p={undo} />;
// export const Redo = p => <Img p={redo} />;
// export const Preview = p => <Img p={preview} />;
export const Container = p => <Img p={container} />;
export const Image = p => <Img p={image} />;
export const Text = p => <Img p={text} />;
export const Slider = p => <Img p={slider} />;
// export const Delete = p => <Img p={remove} />;
// export const Duplicate = p => <Img p={duplicate} />;
// export const BringFront = p => <Img p={bringFront} />;
// export const SendBack = p => <Img p={sendBack} />;
// export const Lock = p => <Img p={lock} />;
// export const Hide = p => <Img p={hide} />;
// export const List = p => <Img p={layers} />;



// WEBPACK FOOTER //
// ./src/reusable/icons.js